/**
 * Maps a full insurer legal name (as delivered by GOS/POL, e.g. "Compensa Vienna Insurance Group ADB Latvijas filiāle")
 * to the short name used across QTG (Compensa, Balcia, BTA, IF, Ergo, Balta, BAN, Gjensidige).
 * Unknown insurers are returned unchanged.
 */
const INSURER_SHORT_NAMES: { pattern: RegExp; shortName: string }[] = [
  // BAN first: its full name also contains other common words
  { pattern: /baltijas\s+apdro[sš]in[aā][sš]anas\s+nams/i, shortName: "BAN" },
  { pattern: /compensa/i, shortName: "Compensa" },
  { pattern: /balcia/i, shortName: "Balcia" },
  { pattern: /\bbta\b/i, shortName: "BTA" },
  { pattern: /\bif\b/i, shortName: "IF" },
  { pattern: /ergo/i, shortName: "Ergo" },
  { pattern: /balta/i, shortName: "Balta" },
  { pattern: /gjensi/i, shortName: "Gjensidige" },
];

export const getInsurerShortName = (
  insurerName: string | null | undefined,
): string => {
  if (!insurerName) return "";
  const match = INSURER_SHORT_NAMES.find((e) => e.pattern.test(insurerName));
  return match ? match.shortName : insurerName;
};
